// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26rbv","title":"styles_title__1qJ11"};